import Vue from "vue";

import Icon from "../views/baseComponents/icon";
import BaseAlert from "../views/baseComponents/baseAlert";
import BaseButton from "../views/baseComponents/baseButton";
import BaseInput from "../views/baseComponents/baseInput";
import BaseLoader from "../views/baseComponents/baseLoader";
import BaseSelect from "../views/baseComponents/baseSelect";
import BaseSelect2 from "../views/baseComponents/baseSelect2";
import BaseSlider from "../views/baseComponents/baseSlider";
import Checkbox from "../views/baseComponents/checkbox";
import FormAutoComplete from "../views/baseComponents/formAutoComplete";
import FormTextArea from "../views/baseComponents/formTextArea";
import FormInput from "../views/baseComponents/formInput";
import Modal from "../views/baseComponents/modal";
import RightModal from "../views/baseComponents/rightModal";
import RadioBtn from "../views/baseComponents/radioBtn";
import BaseSwich from "../views/baseComponents/baseSwich";

Vue.component("Icon", Icon);
Vue.component("BaseAlert", BaseAlert);
Vue.component("BaseButton", BaseButton);
Vue.component("BaseInput", BaseInput);
Vue.component("BaseLoader", BaseLoader);
Vue.component("BaseSelect", BaseSelect);
Vue.component("BaseSelect2", BaseSelect2);
Vue.component("BaseSlider", BaseSlider);
Vue.component("Checkbox", Checkbox);
Vue.component("FormAutoComplete", FormAutoComplete);
Vue.component("FormTextArea", FormTextArea);
Vue.component("FormInput", FormInput);
Vue.component("Modal", Modal);
Vue.component("RightModal", RightModal);
Vue.component("RadioBtn", RadioBtn);
Vue.component("BaseSwich", BaseSwich);
